import { withTimeout } from "@defuse-protocol/internal-utils"

// Slightly above the server-side bound (see `getQuoteWithTimeout` in 1cs.ts) so
// the server's timeout/cancel wins first; this only fires if the server action
// transport itself hangs.
const CLIENT_QUOTE_TIMEOUT_MS = 20_000

/**
 * Fetches an execution (non-dry) 1Click quote exactly once.
 *
 * A non-dry quote mints a non-idempotent 1Click order — a fresh deposit address
 * — on every call, so it must NOT be retried: each retry mints a duplicate order
 * that never receives a deposit, surfacing as an orphaned "failed quote". The
 * server action itself bounds and cancels the underlying request (see
 * `getQuoteWithTimeout` in 1cs.ts); this client-side timeout is only a backstop
 * against a hung server action and performs a single attempt.
 */
export function fetchQuoteOnce<Args extends unknown[], R>(
  quoteFn: (...args: Args) => Promise<R>,
  ...args: Args
): Promise<R> {
  return withTimeout(() => quoteFn(...args), {
    timeout: CLIENT_QUOTE_TIMEOUT_MS,
  })
}
